import { Label } from '@acpaas-ui/react-components';
import { ACTIVITY_TYPES } from '../../../constants/activities.constants';
import { getCategory } from '../../../lib/activity.utils';
import ActivityItemMeta from '../ActivityItemMeta';

const ActivityItem = (props) => {
  const { type, domainObject, message, status, showAsHtml, onStatusClick } = props;
  if (type === ACTIVITY_TYPES.STATUS) {
    return (
      <div className={`spo-m-dossier-sidebar-activity__item spo-m-dossier-sidebar-activity__item--${type}`}>
        <p onClick={onStatusClick}>
          <Label type="success">{status || ''}</Label>
        </p>
      </div>
    );
  }

  if (type === ACTIVITY_TYPES.CHANGE) {
    return (
      <div className={`spo-m-dossier-sidebar-activity__item spo-m-dossier-sidebar-activity__item--${type}`}>
        <ActivityItemMeta {...props} category={getCategory({ domainObject })} />
        {showAsHtml ? (
          <div
            className="spo-m-dossier-sidebar-activity__item-body"
            dangerouslySetInnerHTML={{ __html: message || '' }}
          ></div>
        ) : (
          <div className="spo-m-dossier-sidebar-activity__item-body">{message || ''}</div>
        )}
      </div>
    );
  }

  return null;
};

export default ActivityItem;
